const gbpFmt = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0, minimumFractionDigits: 0 });
const numFmt = new Intl.NumberFormat("en-GB", { maximumFractionDigits: 0 });

const bad = (v) => v === null || v === undefined || Number.isNaN(Number(v));

export function gbp(v) {
  if (bad(v)) return "–";
  const r = Math.round(Number(v));
  if (r === 0) return "£0";
  return (r < 0 ? "−" : "") + gbpFmt.format(Math.abs(r));
}

export function gbpShort(v) {
  if (bad(v)) return "–";
  const a = Math.abs(v);
  const s = v < 0 ? "−" : "";
  if (a >= 1e6) return `${s}£${(a / 1e6).toFixed(1)}m`;
  if (a >= 1e3) return `${s}£${Math.round(a / 1e3)}k`;
  return `${s}£${Math.round(a)}`;
}

export function num(v) {
  if (bad(v) || Math.round(v) === 0) return "–";
  const r = Math.round(v);
  return (r < 0 ? "−" : "") + numFmt.format(Math.abs(r));
}

export function pct(v, dp = 1) {
  if (bad(v)) return "n/a";
  return `${(v * 100).toFixed(dp)}%`;
}

export function multiple(v) {
  if (bad(v)) return "n/a";
  return `${Number(v).toFixed(2)}×`;
}

export function ukDate(iso) {
  if (!iso) return "–";
  const d = new Date(iso.length <= 10 ? `${iso}T00:00:00Z` : iso);
  if (Number.isNaN(d.getTime())) return "–";
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric", timeZone: iso.length <= 10 ? "UTC" : undefined });
}

export function ukDateTime(iso) {
  if (!iso) return "–";
  const d = new Date(iso);
  return `${d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}, ${d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}`;
}

export function quarterOf(iso) {
  if (!iso) return "–";
  const [y, m] = iso.split("-").map(Number);
  return `Q${Math.floor((m - 1) / 3) + 1} ${y}`;
}

export function formatAuditValue(v) {
  if (v === null || v === undefined || v === "") return "–";
  if (typeof v === "number") return Math.abs(v) <= 1 && !Number.isInteger(v) ? pct(v, 2) : gbp(v);
  if (typeof v === "boolean") return v ? "Yes" : "No";
  if (typeof v === "object") return JSON.stringify(v).slice(0, 120);
  return String(v);
}
